import {Component, OnDestroy, OnInit} from '@angular/core';
import {SeoService} from '../_services/seo.service';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {LotteriesService} from '../lotteries.service';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {LogoutService} from '../_services/logout.service';
import {CurrencyService} from '../_services/currency.service';
import * as globals from '../settings';
import {UserService} from '../_services/user.service';
import {Router} from '@angular/router';
import {PackageService, PackageType} from "../_services/package.service";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  pageTitle: string;
  pageDescription: string;
  toggleScratchContent: Subscription;
  toggleContent: boolean;
  isMobile: boolean;
  gameId: string;
  fancyDynamicBanner: string;
  startInstant: Subscription;
  showBanner: boolean;
  fancyBannerMode: string;
  gameMode: string;
  changedCurrency: Subscription;
  currency: any;
  runScratchHome: boolean;
  packageTypes: PackageType
  constructor(private seo: SeoService,
              private translate: TranslateService,
              public lotteryService: LotteriesService,
              private logoutService: LogoutService,
              private subscriptionsService: SubscriptionsService,
              public userService: UserService,
              public router: Router,
              public currencyService: CurrencyService) {
    this.toggleScratchContent = this.subscriptionsService.getToggleContent().subscribe( data => {
      this.gameId = 'off';
      if ( this.lotteryService.isMobile) {
        if (this.toggleContent !== data) {
          // this.toggleContent = data;
        }
      }
    });
    this.fancyDynamicBanner = 'Homepage';
    this.fancyBannerMode = 'default';
    this.gameMode = 'homepage';

    this.currency = this.currencyService.currency;
    this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
      if (currency) {
        this.currency = currency;
        this.runScratchHome = false;
        setTimeout(() => {
          this.runScratchHome = true;
        }, 500);
      }
    });

    this.runScratchHome = true;
    this.packageTypes = PackageService.types;
  }

  ngOnInit() {
    this.showBanner = true;
    this.logoutService.loggedInCheck();
    this.toggleContent = true;
    this.setMetaTags();

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.setMetaTags();
    });
    this.startInstant = this.subscriptionsService.getStartInstant().subscribe( data => {
      if (data) {

         this.gameId = data;
      }
    });
  }
  ngOnDestroy() {
    this.showBanner = false;
    if (this.startInstant) {
      this.startInstant.unsubscribe();
    }
    if (this.toggleScratchContent) {
      this.toggleScratchContent.unsubscribe();
    }
    if (this.changedCurrency) {
      this.changedCurrency.unsubscribe();
    }
  }

  setMetaTags() {
    if (this.translate.currentLang === 'de') {
      this.seo.setTitle('Spielen Sie bei STG Demo Lotto ™ | Top Lotterien und Rubbellose online');
      this.seo.setDescription('Spielen Sie die weltweit größten Lotterien online - Powerball, EM Millions, Mega Millions sowie Rubbellose,' +
        ' Spiele und mehr! 100% garantierte Auszahlungen, staatlich lizensiert.');
    } else if (this.translate.currentLang === 'vi') {
      this.seo.setTitle('Chơi STG Demo Lotto™ | Xổ số và thẻ cào lớn nhất');
      this.seo.setDescription('Chơi xổ số trực tuyến lớn nhất thế giới - Powerball, EM Millions, Mega Millions cộng với thẻ cào, trò chơi và hơn thế nữa! Cashouts được đảm bảo 100%, được chính phủ cấp phép.');
    } else if (this.translate.currentLang === 'id') {
      this.seo.setTitle('Bermain di STG Demo Lotto™ | Kartu Lotere dan Gosok Terbesar');
      this.seo.setDescription('Mainkan lotere online terbesar di dunia - Powerball, Jutaan EM, Jutaan Mega plus kartu gosok, game, dan lainnya! Pembayaran 100% Dijamin, Lisensi Pemerintah.');
    } else {
      this.seo.setTitle('Play at STG Demo Lotto™ | Biggest Lottery and Scratch cards');
      this.seo.setDescription('Play the world\'s biggest lotteries online - Powerball, EM Millions, Mega Millions plus scratch cards, games ' +
        'and more! Cashouts 100% Guaranteed, Government Licensed.');
    }
  }

}
